import { Routes, Route } from 'react-router-dom';
import SubscribePage from './features/subscribe/SubscribePage';
import SubscribeThankYouPage from './features/subscribe/SubscribeThankYouPage';
import SubscribeErrorPage from './features/subscribe/SubscribeErrorPage';
import UnsubscribePage from './features/unsubscribe/UnsubscribePage';
import NotFoundPage from './features/shared/NotFoundPage';

/**
 * /:slug/dziekujemy and /:slug/blad are real routes (not a modal) — matches the base Symfony
 * app's behavior exactly: a dedicated page reachable at a stable URL, no popup.
 */
export default function AppRouter() {
  return (
    <Routes>
      <Route path="/rezygnacja/:slug" element={<UnsubscribePage />} />
      <Route path="/:slug/dziekujemy" element={<SubscribeThankYouPage />} />
      <Route path="/:slug/blad" element={<SubscribeErrorPage />} />
      <Route path="/:slug" element={<SubscribePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
